import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Outstationtaxiserviceinmumbai() {



const cardData = {
  keyword: " Outstation Taxi Service in Mumbai",

headingDescription:
  "Omshree Cab offers dependable and comfortable outstation taxi service in Mumbai for travelers who want to explore nearby cities, pilgrimage sites, hill stations, beaches, and major destinations across Maharashtra and beyond. Whether you need a taxi for weekend getaways, family trips, corporate outstation travel, or long‑distance journeys from Mumbai, our service ensures a smooth, safe, and hassle‑free experience with professional drivers and well‑maintained vehicles. We provide flexible booking options including one‑way trips, round‑trip packages, and multi‑day plans with transparent per‑kilometer pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, multi‑purpose vehicles (MPVs), and tempo travelers suitable for solo travelers, families, groups, and corporate clients. With experienced chauffeurs skilled in long‑distance routes, punctual pickups from any location in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for outstation taxi services from Mumbai.",

topPlaces: [
  {
    title: "Pune",
    description:
      "Pune is a major cultural and historical city near Mumbai known for its forts, hill stations, gardens, and growing IT and education hubs. Popular attractions include Shaniwar Wada, Sinhagad Fort, Aga Khan Palace, and Osho Ashram. An outstation taxi service makes it easy to travel from Mumbai to Pune comfortably, allowing you to explore history, food culture, and scenic spots while enjoying a smooth ride across the Mumbai‑Pune Expressway."
  },
  {
    title: "Lonavala & Khandala",
    description:
      "Lonavala and Khandala are famous hill stations near Mumbai, offering cool weather, lush green valleys, waterfalls, and scenic viewpoints like Tiger’s Leap, Bushi Dam, and Lion’s Point. These destinations are ideal for weekend trips and nature getaways. An outstation taxi from Mumbai gives you the flexibility to plan stops for sightseeing, photography, and relaxation along the way."
  },
  {
    title: "Mahabaleshwar & Panchgani",
    description:
      "Mahabaleshwar and Panchgani are popular hill stations in the Sahyadri range known for strawberry farms, viewpoints like Arthur’s Seat and Table Land, and pleasant weather throughout the year. Traveling by outstation taxi allows you to explore panoramic landscapes, enjoy local produce, and visit scenic spots at your own pace with the comfort of a private ride."
  },
  {
    title: "Alibaug",
    description:
      "Alibaug is a coastal town near Mumbai known for its sandy beaches, relaxed ambiance, and historic forts like Kolaba Fort. Popular beaches include Alibaug Beach, Nagaon Beach, and Kihim Beach, ideal for families and honeymooners. An outstation taxi from Mumbai ensures a comfortable coastal drive and offers the flexibility to visit beaches, forts, and markets at leisure."
  },
  {
    title: "Goa",
    description:
      "Goa is one of India’s most popular beach destinations, known for its golden sandy beaches, vibrant nightlife, historic churches, and seafood cuisine. An outstation taxi service from Mumbai to Goa lets you plan the road trip with comfort and flexibility, stopping at scenic points, roadside dhabas, and viewpoints while enjoying the long drive to the Konkan coast."
  },
  {
    title: "Shirdi",
    description:
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, where devotees visit the Sai Baba Temple for darshan, aarti, and spiritual experiences. An outstation taxi from Mumbai to Shirdi offers a convenient and comfortable way to reach the holy town while allowing devotees to plan rest stops and local sightseeing along the route."
  },
  {
    title: "Kolhapur",
    description:
      "Kolhapur is a historic city known for the Mahalakshmi Temple, Rankala Lake, and spicy Kolhapuri cuisine. It is a popular destination for pilgrims, food lovers, and cultural explorers. Traveling by outstation taxi from Mumbai gives you a private and comfortable journey to this cultural hub with the freedom to explore the city at your pace."
  },
  {
    title: "Aurangabad",
    description:
      "Aurangabad is home to UNESCO World Heritage Sites including the Ajanta and Ellora Caves, along with historic forts, temples, and museums. An outstation taxi from Mumbai makes it easy to reach these archaeological wonders and enjoy scenic drives while exploring the rich historical and cultural heritage of the region."
  },
  {
    title: "Nashik",
    description:
      "Nashik is a spiritual and wine‑tourism destination known for the Trimbakeshwar Temple, Sula Vineyards, and scenic ghats of the Godavari River. An outstation taxi service from Mumbai provides a comfortable travel option to visit temples, vineyards, and nearby attractions without worrying about local commuting or transport arrangements."
  },
  {
    title: "Konkan Coast Drive",
    description:
      "The Konkan Coast Drive from Mumbai covers scenic coastal towns, pristine beaches, forts, and waterfalls along the western coast of India. Highlights include Ganpatipule, Ratnagiri, Tarkarli, and Velas. An outstation taxi allows you to explore the Konkan region at your own pace with stops at hidden gems and local eateries, making the journey as memorable as the destination."
  }
],



services: [
{
name: "Outstation Taxi Service Mumbai",
description: "Outstation taxi service in Mumbai provides comfortable transportation for travelers planning trips outside the city. Vehicles are suitable for long-distance highway journeys connecting Mumbai with major destinations across Maharashtra and India. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and airport terminals. Ideal for weekend trips, pilgrimage travel, business journeys, and family vacations. Air-conditioned vehicles ensure comfortable travel experiences throughout the journey. Flexible booking options allow passengers to schedule outstation taxis easily."
},
{
name: "Mumbai Outstation Cab Service",
description: "Mumbai outstation cab service offers reliable intercity transportation for travelers planning journeys beyond city limits. The service includes comfortable vehicles suitable for highway travel and extended trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, business meetings, and family trips. Spacious vehicles ensure comfortable journeys for passengers. Flexible booking options allow convenient outstation travel planning."
},
{
name: "Taxi Service in Mumbai for Outstation",
description: "Taxi service in Mumbai for outstation travel provides convenient transportation for passengers planning long-distance journeys from Mumbai to nearby cities and tourist destinations. Vehicles are well maintained and suitable for highway driving. Professional drivers ensure safe travel and punctual pickup services across the city. Pickup services are available from homes, offices, hotels, railway stations, and airports. Ideal for pilgrimage tours, family travel, and business trips. Comfortable interiors ensure relaxed journeys. Flexible booking options allow easy cab reservations."
},
{
name: "Outstation Cab Booking Mumbai",
description: "Outstation cab booking in Mumbai allows travelers to easily reserve taxis for intercity travel and long-distance journeys. Online and phone booking options provide instant confirmation and convenient scheduling. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism visits, corporate travel, and family trips. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options make travel planning simple."
},
{
name: "Mumbai to Outstation Taxi",
description: "Mumbai to outstation taxi service offers reliable transportation from Mumbai to nearby cities, tourist destinations, and pilgrimage sites. Vehicles are suitable for highway travel and provide comfortable seating for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airports. Ideal for family vacations, temple visits, and business trips. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow convenient travel reservations."
},
{
name: "One Way Outstation Cab Mumbai",
description: "One way outstation cab in Mumbai offers economical transportation for travelers planning intercity journeys without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for long trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for airport transfers, business trips, and tourism travel. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow quick ride reservations."
},
{
name: "Round Trip Taxi Mumbai",
description: "Round trip taxi service in Mumbai provides convenient transportation for travelers planning return journeys to outstation destinations. Vehicles are suitable for long-distance highway travel and multi-day trips. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family vacations, temple tours, and business travel. Comfortable seating ensures relaxed journeys throughout the trip. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Cheap Outstation Cab Mumbai",
description: "Cheap outstation cab in Mumbai offers affordable transportation for travelers seeking economical long-distance travel options. Budget-friendly vehicles provide comfortable seating and reliable performance suitable for intercity journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airports. Ideal for students, tourists, and budget travelers. Air-conditioned vehicles ensure comfortable travel experiences. Flexible booking options allow economical travel planning."
},
{
name: "Best Outstation Taxi Service Mumbai",
description: "Best outstation taxi service in Mumbai provides reliable and professional transportation for long-distance journeys from the city. The service offers well-maintained vehicles and experienced drivers for safe highway travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for business travel, family vacations, and pilgrimage trips. Comfortable interiors ensure relaxed travel experiences. Professional service ensures punctuality and safety throughout the journey. Flexible booking options allow easy reservations."
},
{
name: "Outstation Car Rental Mumbai",
description: "Outstation car rental in Mumbai offers convenient vehicle hire services for travelers planning long-distance journeys outside the city. Rental vehicles are suitable for highway travel and multi-day trips. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for tourism travel, family vacations, and corporate trips. Spacious vehicles ensure comfortable journeys. Flexible rental plans allow convenient travel scheduling."
},
{
name: "Innova Outstation Cab Mumbai",
description: "Innova outstation cab in Mumbai provides spacious and comfortable MPV transportation for long-distance journeys. The Toyota Innova offers premium seating and smooth highway travel suitable for family trips and group travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for family vacations, corporate travel, and temple tours. Comfortable interiors ensure relaxed journeys. Flexible booking options allow convenient travel planning."
},
{
name: "Ertiga Outstation Taxi Mumbai",
description: "Ertiga outstation taxi in Mumbai offers comfortable MPV transportation for travelers planning long-distance journeys. The Maruti Ertiga provides spacious seating and smooth ride quality suitable for highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family travel, tourism trips, and business journeys. Air-conditioned interiors ensure comfortable travel experiences. Flexible booking options allow easy ride reservations."
},
{
name: "Sedan Outstation Cab Mumbai",
description: "Sedan outstation cab in Mumbai offers economical and comfortable transportation for long-distance travel. Sedan vehicles provide smooth driving performance and comfortable seating suitable for intercity journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business trips, airport transfers, and tourism travel. Air-conditioned vehicles ensure relaxed journeys for passengers. Flexible booking options allow convenient travel planning."
},
{
name: "SUV Outstation Taxi Mumbai",
description: "SUV outstation taxi in Mumbai provides powerful and spacious vehicles suitable for long-distance travel and highway journeys. SUVs offer comfortable seating and extra luggage space ideal for group travel and family vacations. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for adventure trips, tourism travel, and group journeys. Spacious interiors ensure comfortable travel experiences. Flexible booking options allow easy reservations."
},
{
name: "Luxury Outstation Cab Mumbai",
description: "Luxury outstation cab in Mumbai provides premium transportation services for travelers seeking stylish and comfortable long-distance travel. Luxury vehicles offer spacious seating, elegant interiors, and smooth highway performance. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for VIP travel, corporate executives, and special journeys. Premium interiors ensure relaxing travel experiences. Flexible booking options allow convenient luxury travel planning."
},
{
name: "Corporate Outstation Taxi Mumbai",
description: "Corporate outstation taxi in Mumbai provides reliable transportation for business professionals traveling to other cities for meetings and corporate events. Vehicles offer comfortable seating and professional travel suitable for executives and employees. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from offices, hotels, airports, and business districts. Ideal for corporate meetings, conferences, and business trips. Comfortable vehicles ensure relaxed journeys for professionals. Flexible booking options allow companies to plan travel efficiently."
}
],

tableData: [
["Outstation Taxi Service Mumbai","Mumbai Outstation Cab Service"],
["Taxi Service in Mumbai for Outstation","Outstation Cab Booking Mumbai"],
["Mumbai to Outstation Taxi","One Way Outstation Cab Mumbai"],
["Round Trip Taxi Mumbai","Cheap Outstation Cab Mumbai"],
["Best Outstation Taxi Service Mumbai","Outstation Car Rental Mumbai"],
["Innova Outstation Cab Mumbai","Ertiga Outstation Taxi Mumbai"],
["Sedan Outstation Cab Mumbai","SUV Outstation Taxi Mumbai"],
["Luxury Outstation Cab Mumbai","Corporate Outstation Taxi Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Outstation Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance travel from Mumbai to various cities across Maharashtra and India. They are familiar with highways, ghat roads, and popular travel routes ensuring a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Transparent Outstation Taxi Pricing",
    WhyChoosedescription: "Omshree Cabs provides clear and transparent pricing for outstation taxi services in Mumbai. Customers receive detailed information about per-kilometer rates, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our outstation taxi service from Mumbai is available 24 hours a day. Whether you need an early morning departure or late-night travel, Omshree Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized to provide passengers with a safe and comfortable travel experience."
  },
  {
    WhyChooseheading: "Flexible Outstation Travel Packages",
    WhyChoosedescription: "We offer flexible travel options including one-way cabs, round trips, and multi-day outstation packages for destinations like Pune, Lonavala, Nashik, Shirdi, Surat, and many more."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury cars like Innova Crysta, and Tempo Travellers suitable for families and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your outstation journey begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for reliable outstation taxi services from Mumbai. Our punctual drivers, comfortable vehicles, and professional service ensure a pleasant travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide outstation taxi services from Mumbai?", answer: "Yes, Omshree Cabs provides outstation taxi services from Mumbai to destinations like Pune, Lonavala, Nashik, Shirdi, Surat, and many other cities." },
  { question: "Can I book a one-way outstation cab from Mumbai?", answer: "Yes, we offer both one-way and round-trip outstation taxi services from Mumbai." },
  { question: "Which vehicles are available for outstation travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers depending on the group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our outstation taxi service from Mumbai operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, sightseeing, or refreshment breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and tourist seasons." },
  { question: "Do you provide airport pickup for outstation trips?", answer: "Yes, we provide direct pickup from Mumbai Airport for outstation taxi bookings." },
  { question: "Do you offer multi-day travel packages?", answer: "Yes, we provide customized multi-day outstation travel packages from Mumbai." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Mehta",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Nashik outstation trip. The car was clean and the driver was very professional. Great experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Shah",
    feedback:
      "Very reliable outstation taxi service from Mumbai. Smooth journey, comfortable vehicle, and transparent pricing.",
    rating: 5
  }
];














































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Taxi Service in Mumbai",
  "description": "Omshree Cab offers reliable outstation taxi services in Mumbai for one-way trips, round trips, corporate travel, and luxury journeys. Choose from Innova, Ertiga, Sedan, and SUV cabs for comfortable, safe, and budget-friendly travel to any outstation destination from Mumbai. Flexible booking options and transparent pricing ensure a hassle-free experience.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2100"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Outstation Taxi Service in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides outstation taxi services in Mumbai for one-way and round trips, corporate and luxury travel. Choose Innova, Ertiga, Sedan, or SUV cabs for safe, comfortable, and budget-friendly journeys with transparent pricing." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationtaxiserviceinmumbai;